import React from 'react';

import {StarRating} from '@optimaxdev/design-system';
import {Icon, TrustPilot} from '@optimaxdev/icons';

import s from './trustpilotExcellent.scss';

const BENEFITS = [
    {
        title: 'Free shipping & Returns',
    },
    {
        title: '100% Money back guarantee',
    },
    {
        title: '365 day warranty',
    },
];

/**
 * Ctp Trustpilot excellent, it shows when trustpilot return score less 4.5
 */
export const TrustpilotExcellent = ({numberOfReviews}: {numberOfReviews?: number}) => {
    return (
        <>
            <ul className={s.benefits}>
                {BENEFITS.map(benefit => (
                    <li className={s.benefitItem} key={benefit.title}>
                        <span className={s.benefitText}>{benefit.title}</span>
                    </li>
                ))}
            </ul>
            <div className={s.wrapper}>
                <Icon className={s.trustpilotIcon} icon={TrustPilot} />
                <StarRating gap={2} rating={90} size={18} type="trustpilot" />
                <span className={s.reviewsCount}>
                    {numberOfReviews ? `${numberOfReviews.toLocaleString('en-US')}` : '67,848'}
                </span>
            </div>
        </>
    );
};
